export const CHALLENGE_UNIT_USER = 'User';
export const CHALLENGE_UNIT_TEAM = 'Team';
export const CHALLENGE_PARTICIPATION_JOINED_STATUS = 'joined';
export const CHALLENGE_PARTICIPATION_UN_JOINED_STATUS = 'unjoined';
export const CHALLENGE_PARTICIPATION_INVITED_STATUS = 'invited';
